import React, { useEffect } from "react";
import { ReactComponent as Logo } from "../../assets/icons/Group 1.svg";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
const Splash = ({ isLogin, firstVisit }) => {
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addToHome");
    } else {
      if (isLogin) {
        history.push("/Main");
      } else {
        history.push("/Login");
      }
    }
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div className="splash">
        <Logo />
        <span>مدیریت هوشمند قبوض شرکت های خدماتی</span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLogin,
    firstVisit: state.auth.firstVisit,
  };
};

export default connect(mapStateToProps)(Splash);
